import React, { useRef } from 'react';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';
import Page from '@/Pages/Page';
import PageContentLoading from '../../../PageContentLoading';
import ModifyRecruitmentStepper from '../Components/ModifyRecruitmentStepper';
import { CreateFullRecruitmentStepMapper } from '../Components/StepMappers';
import { useCreateRecruitmentContext } from './Contexts/CreateRecruitmentContext';
import { useAssessmentSettings } from '@/api/useAssessmentSettings';
import TopBar from '@/Components/TopBars/TopBar';

const CreateRecruitmentPageContent = () => {
    const { processingState, gettingDataProcessingState } = useCreateRecruitmentContext();
    const { isLoading: isAssessmentSettingsLoading } = useAssessmentSettings();
    const pageContentContainerRef = useRef<HTMLDivElement>(null);
    const isLoading = gettingDataProcessingState === ProcessingState.Processing || isAssessmentSettingsLoading;
    const steps = [
        UIStrings.JobDetails,
        UIStrings.JobDescription,
        UIStrings.SkillsTests,
        UIStrings.ApplicantInformation,
        UIStrings.IdentifyExperience,
    ];

    return (
        <Page
            topBar={<TopBar onlyLogo />}
            pageContainerProps={{ className: 'h-screen' }}
            pageContentContainerProps={{
                className: 'relative grow',
                style: {},
                ref: pageContentContainerRef,
            }}
        >
            <PageContentLoading
                isLoading={isLoading}
                loadingFailed={
                    processingState === ProcessingState.Error || gettingDataProcessingState === ProcessingState.Error
                }
            >
                <ModifyRecruitmentStepper
                    steps={steps}
                    stepMapper={CreateFullRecruitmentStepMapper}
                    containerRef={pageContentContainerRef}
                />
            </PageContentLoading>
        </Page>
    );
};

export default CreateRecruitmentPageContent;
